import { render, staticRenderFns } from "./NewsAlert.vue?vue&type=template&id=35e57c33"
import script from "./NewsAlert.vue?vue&type=script&lang=js"
export * from "./NewsAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports